export default {
  'nav.brandVision': '品牌願景',
  'nav.strategicPositioning': '戰略定位',
  'nav.coreBusiness': '核心業務',
  'nav.competitiveAdvantage': '競爭優勢',
  'nav.developmentRoadmap': '發展路線',
  'nav.careers': '人才招聘',
  'nav.backToHome': '返回首頁',
  'nav.brandStory': '品牌故事',

  'footer.companyName': '艾思國際控股有限公司',
  'footer.companyNameEn': 'AX AXIS INTERNATIONAL HOLDING LIMITED',
  'footer.tagline': '讓數據回歸核心。從底層芯片到頂層架構，構建全鏈路私域數據生態。',
  'footer.business': '業務板塊',
  'footer.business.storageChips': '存儲芯片',
  'footer.business.terminalDevices': '終端設備',
  'footer.business.privateCloudNAS': '私有雲 NAS',
  'footer.business.enterpriseNetwork': '企業網絡',
  'footer.aboutUs': '關於我們',
  'footer.aboutUs.brandVision': '品牌願景',
  'footer.aboutUs.strategicPositioning': '戰略定位',
  'footer.aboutUs.developmentRoadmap': '發展路線',
  'footer.aboutUs.careers': '人才招聘',
  'footer.contact': '聯繫合作',
  'footer.addressLine1': '香港中環德輔道中26號華懋中心二期19樓A室',
  'footer.phoneLabel': '電話：',
  'footer.emailLabel': '郵箱：',
  'footer.copyright': '© {{year}} AX Axis International Holding Limited. All rights reserved.',

  'contact.infoTitle': '聯絡方式',
  'contact.addressTitle': '公司地址',
  'contact.emailTitle': '電子郵箱',
  'contact.reachUs': '',
  'contact.web3MissingKey': 'Web3Forms 訪問密鑰未配置，請聯繫管理員。',

  'contact.label': '',
  'contact.title': '聯絡我們',
  'contact.description': '有任何疑問或合作意向，歡迎留言，我們將盡快與您取得聯繫。',
  'contact.nameLabel': '姓名',
  'contact.namePlaceholder': '請輸入您的姓名',
  'contact.emailLabel': '郵箱',
  'contact.emailPlaceholder': 'your@email.com',
  'contact.phoneLabel': '電話',
  'contact.phonePlaceholder': '您的聯繫電話（選填）',
  'contact.messageLabel': '查詢內容',
  'contact.messagePlaceholder': '請描述您的需求或問題...',
  'contact.submit': '發送留言',
  'contact.submitting': '發送中...',
  'contact.success': '留言發送成功！',
  'contact.error': '請檢查填寫內容後重試。',
};